import { Injectable, Inject } from '@angular/core';
import { Observable, of, from } from 'rxjs';
import { RECAPTCHA_CONFIG, RecaptchaConfig } from '../tokens';
declare const grecaptcha: any;

@Injectable({ providedIn: 'root' })
export class RecaptchaEnterpriseService {
  constructor(
    @Inject(RECAPTCHA_CONFIG)
    private config: RecaptchaConfig,
  ) {}

  execute(action: string = 'LOGIN'): Observable<string> {
    if (!this.config.enabled) {
      return of('');
    }

    return from<string>(grecaptcha.enterprise.execute(this.config.siteKey, { action }));
  }
}
